import { AuthenticationResult } from "@azure/msal-browser";
import { getFfToken, setOptionHeaders } from "../auth/getAccessToken";

export class ClientBaseFeatureFlag {
  protected async transformOptions(options: RequestInit): Promise<RequestInit> {
    let token: AuthenticationResult = await getFfToken();
    setOptionHeaders(options, token.accessToken);

    return Promise.resolve(options);
  }
}
